import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import UnitEdits from "../../components/Units/UnitEdit";


const UnitEdit = () => {
  return (
    <>


        {/* Breadcrumb */}
        {/* <Breadcrumb title="Edit Unit" /> */}
        <div className="d-flex justify-content-between"><h5>Edit Unit </h5><Breadcrumb title="Edit Unit" /></div>

        {/* UsersListLayer */}
        <UnitEdits />



    </>
  );
};

export default UnitEdit; 